import React, { useEffect, useState } from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { fetchDashboardTopLocation } from "../../api/region";

// Example Data


// const maxUsers = topLocations[0].users; // highest user count for scaling

const TopUserLocations = () => {
  const { filter } = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(true);
  const [topLocations, setTopLocations] = useState([]);
  const [maxUsers, setMaxUsers] = useState(0);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const data = await fetchDashboardTopLocation(filter);      
      const country = data.country.filter((item) => item._id !== null);
      setMaxUsers(country[0]?.count);
      setTopLocations(country||[]);
      setIsLoading(false);
    } catch (err) {
      console.error('Error while loading user data', err);
    }
  };
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filter)]);
  return (
    <Box sx={{ border: '1px solid #E8E8E8', p: 3, borderRadius: '12px' }}>
      <Typography fontWeight={500} mb={2} sx={{ fontSize: '20px', color: '#3C4043' }}>
        Top User Locations
      </Typography>

      {!isLoading && topLocations.map((location, index) => {
        const percentage = (location.count / maxUsers) * 100;
        return (
          <Box key={index} mb={2}>
            <Box display="flex" justifyContent="space-between" mb={0.5}>
              <Typography fontSize={14} color="#343A40" fontWeight={500}>{location._id}</Typography>
              <Typography fontSize={14} fontWeight={500}>
                {location.count.toLocaleString()}
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={percentage}
              sx={{
                height: 12,
                borderRadius: 5,
                backgroundColor: "#eee",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "#007FFF", // Customize color
                },
              }}
            />
          </Box>
        );
      })}

      {
        !isLoading && !Boolean(topLocations?.length) &&
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            No data available
          </Typography>
        </Box>
      }
      {isLoading && <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          Loading...
        </Typography>
      </Box>}
    </Box>
  );
};

export default TopUserLocations;
